var map = {
	"./ion-action-sheet.entry.js": [
		243,
		7
	],
	"./ion-alert.entry.js": [
		244,
		8
	],
	"./ion-app_8.entry.js": [
		245,
		9
	],
	"./ion-avatar_3.entry.js": [
		246,
		19
	],
	"./ion-back-button.entry.js": [
		247,
		20
	],
	"./ion-backdrop.entry.js": [
		248,
		45
	],
	"./ion-button_2.entry.js": [
		249,
		21
	],
	"./ion-card_5.entry.js": [
		250,
		22
	],
	"./ion-checkbox.entry.js": [
		251,
		23
	],
	"./ion-chip.entry.js": [
		252,
		24
	],
	"./ion-col_3.entry.js": [
		253,
		46
	],
	"./ion-datetime_3.entry.js": [
		254,
		12
	],
	"./ion-fab_3.entry.js": [
		255,
		25
	],
	"./ion-img.entry.js": [
		256,
		47
	],
	"./ion-infinite-scroll_2.entry.js": [
		257,
		48
	],
	"./ion-input.entry.js": [
		258,
		26
	],
	"./ion-item-option_3.entry.js": [
		259,
		27
	],
	"./ion-item_8.entry.js": [
		260,
		28
	],
	"./ion-loading.entry.js": [
		261,
		29
	],
	"./ion-menu_3.entry.js": [
		262,
		30
	],
	"./ion-modal.entry.js": [
		263,
		10
	],
	"./ion-nav_2.entry.js": [
		264,
		16
	],
	"./ion-popover.entry.js": [
		265,
		11
	],
	"./ion-progress-bar.entry.js": [
		266,
		31
	],
	"./ion-radio_2.entry.js": [
		267,
		32
	],
	"./ion-range.entry.js": [
		268,
		33
	],
	"./ion-refresher_2.entry.js": [
		269,
		13
	],
	"./ion-reorder_2.entry.js": [
		270,
		18
	],
	"./ion-ripple-effect.entry.js": [
		271,
		49
	],
	"./ion-route_4.entry.js": [
		272,
		34
	],
	"./ion-searchbar.entry.js": [
		273,
		35
	],
	"./ion-segment_2.entry.js": [
		274,
		36
	],
	"./ion-select_3.entry.js": [
		275,
		37
	],
	"./ion-slide_2.entry.js": [
		276,
		50
	],
	"./ion-spinner.entry.js": [
		277,
		15
	],
	"./ion-split-pane.entry.js": [
		278,
		51
	],
	"./ion-tab-bar_2.entry.js": [
		279,
		38
	],
	"./ion-tab_2.entry.js": [
		280,
		17
	],
	"./ion-text.entry.js": [
		281,
		39
	],
	"./ion-textarea.entry.js": [
		282,
		40
	],
	"./ion-toast.entry.js": [
		283,
		41
	],
	"./ion-toggle.entry.js": [
		284,
		14
	],
	"./ion-virtual-scroll.entry.js": [
		285,
		52
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 142;
module.exports = webpackAsyncContext;